<template>
  <div class="change-passsword">
    <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
      <a-form-model-item label="原密码" prop="password">
        <a-input size="large" v-model="form.password" placeholder="请输入原密码" allow-clear type="password"></a-input>
      </a-form-model-item>
      <a-form-model-item label="新密码" prop="newPassword">
        <a-input size="large" v-model="form.newPassword" placeholder="请输入新密码" allow-clear type="password"></a-input>
      </a-form-model-item>
      <a-form-model-item label="重复密码" prop="repeatPassword">
        <a-input size="large" v-model="form.repeatPassword" placeholder="请输入重复密码" allow-clear type="password"></a-input>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import UserService from '@/io/user.js';

  export default {
    name: 'ChangePassword',
    data() {
      return {
        form: {
          password: null,
          newPassword: null,
          repeatPassword: null
        },
        rules: {
          password: [
            {
              required: true,
              message: '请填写原密码'
            }
          ],
          newPassword: [
            {
              required: true,
              message: '请填写新密码'
            }
          ],
          repeatPassword: [
            {
              required: true,
              message: '请填写重复密码'
            },
            {
              validator: this.$debounce((rule, value, callback) => {
                if (value && value !== this.form.newPassword) {
                  callback(new Error('两次密码输入不一致'));
                } else {
                  callback();
                }
              })
            }
          ]
        }
      }
    },
    methods: {
      submit(callback = () => {}) {
        this.$beforeFormSubmit(this.$refs.form, () => {
          UserService.resetPassword(
            this.form.password,
            this.form.newPassword,
            this.form.repeatPassword
          ).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              callback();
            });
          }).catch(err => {});
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>